import React, { Component } from 'react';
import PropTypes from 'prop-types';

const styles = {
  blue: {
    color: 'rgba(51, 163, 243, 1.0)',
  },
  red: {
    color: 'rgba(243, 83, 83, 1.0)',
  },
  status: {
    fontWeight: 600,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
};

export default class PublishItem extends Component {
  render() {
    const { isPublished, title, id } = this.props;
    return (
      <div className="create-entry-schedule-item">
        <div style={{ ...styles.row }}>
          <div className="create-entry-schedule-platform" style={{ flex: 1 }}>{title}</div>
          { isPublished && !id &&
            <div style={{ ...styles.blue, ...styles.status }}>Show</div>
          }
          { !isPublished && !id &&
            <div style={{ ...styles.red, ...styles.status }}>Don't Show</div>
          }
          { id && <div style={{ ...styles.blue, ...styles.status }}>Already Published</div> }
        </div>
      </div>
    );
  }
}

PublishItem.propTypes = {
  isPublished: PropTypes.bool,
  date: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/cms/entry/blitz/PublishItem.js